"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _MarketingStarterUpgradeBanner = _interopRequireDefault(require("lead-flows-ui/components/common/MarketingStarterUpgradeBanner"));

var _default = _react.default.createClass({
  displayName: "BrandingConfig",
  propTypes: {
    brandingEnabled: _react.default.PropTypes.bool.isRequired
  },
  langKey: function langKey(suffix) {
    return "leadFlowEditor.leadFlowOptionsEditor.branding." + suffix;
  },
  render: function render() {
    if (!this.props.brandingEnabled) return null;
    return _react.default.createElement("div", {
      className: "branding-banner"
    }, _react.default.createElement(_MarketingStarterUpgradeBanner.default, {
      screen: "dyno-editor-options-branding"
    }));
  }
});

exports.default = _default;
module.exports = exports.default;